module.exports = __webpack_public_path__ + "img/after.981866ce.jpg";